import { connect } from 'react-redux';
import App from '../components/App'
import { authenticate } from '../actions';
import {getHttpClient} from '../services/CommonServices';

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateUser: (data) => {
      dispatch(authenticate(data));
    },
  };
};

window.Skye.HttpClient = getHttpClient();

const AppContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default AppContainer;
